module.exports = __webpack_public_path__ + "img/support.578792a1.svg";